"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commercialFilterParamsChanged = void 0;

var _Schema = require("../../Schema");

/**
 * A user changed filters on the main artworkGrid
 *
 * @example
 * ```
 * commercialFilterParamsChanged({
 *   context_owner_type: OwnerType.artist,
 *   context_owner_id: "58ba65b1275b24421f80a102",
 *   context_owner_slug: "tugo-cheng",
 *   changed: '{"acquireable": 1, "priceRange": "1000-5000"}',
 *   current: '{"acquireable": 0, "priceRange": "*-*"}'
 * })
 * ```
 */
var commercialFilterParamsChanged = function commercialFilterParamsChanged(_ref) {
  var changed = _ref.changed,
      contextOwnerId = _ref.contextOwnerId,
      contextOwnerSlug = _ref.contextOwnerSlug,
      contextOwnerType = _ref.contextOwnerType,
      current = _ref.current;
  return {
    action: _Schema.ActionType.commercialFilterParamsChanged,
    changed: changed,
    context_module: _Schema.ContextModule.artworkGrid,
    context_owner_id: contextOwnerId,
    context_owner_slug: contextOwnerSlug,
    context_owner_type: contextOwnerType,
    current: current
  };
};

exports.commercialFilterParamsChanged = commercialFilterParamsChanged;